/**
 * List of transport formats
 *   - TS (MPEG-2 TS)
 *   - MP$ (Fragmented MP4)
 */
var TransportFormat = {
  MP4: 'MP4',
  MPEG2: 'TS'
}
module.exports = TransportFormat
